import { customerRequestWords } from "./state-words.js";
// The words a customer reads about the state of a request (contract 7.5). One closed text per state. The text
// never comes from a model, from staff or from the customer, so nothing in it can promise a booking, a time, a
// price or a supplier fact. "Confirmed" appears only for the state CONFIRMED, and "paid" and "booked" appear nowhere:
// a request is staff work, and a payment is a separate flow. Lane R5 (`request-projection.ts`) reuses this function.
//
// The texts are defined once, in `state-words.ts` (CHT-1990), next to every other word of a request state. This file keeps the names that
// the server code already uses.
export { REQUEST_STATUS_TEXT } from "./state-words.js";
/** The customer-visible status text of a state. Pure and closed. */
export function requestCustomerStatusText(state) {
    return customerRequestWords(state).text;
}
